// App utils
import { datajsAll, datajs, trapFocus, collapseOpenSiteNavItems } from '../shared/utils';

export default class OffCanvasNav {
	static init() {
		const siteHeader = datajs('site-header');
		const showMenuElement = datajs('show-off-canvas-section');
		const hideMenuElements = datajsAll('hide-off-canvas-section');
		let isTransitioning = false;

		const showOffCanvasSection = () => {
			if (isTransitioning) {
				return false;
			}

			isTransitioning = true;
			trapFocus(document.getElementById('off-canvas-section'));
			showMenuElement.setAttribute('aria-expanded', 'true');
			hideMenuElements.forEach((item) => {
				item.setAttribute('aria-expanded', 'true');
			});

			// Transition CSS class 1
			document.body.classList.add('has-activated-menu');

			// Transition CSS class 2
			setTimeout(function () {
				document.body.classList.add('has-menu');
				isTransitioning = false;
			}, 10);

			return false;
		};

		const hideOffCanvasSection = () => {
			if (isTransitioning) {
				return false;
			}

			isTransitioning = true;
			showMenuElement.setAttribute('aria-expanded', 'false');
			hideMenuElements.forEach((item) => {
				item.setAttribute('aria-expanded', 'false');
			});

			// Remove Transition CSS class 2
			document.body.classList.remove('has-menu');

			// Remove Transition CSS class 1
			setTimeout(function () {
				document.body.classList.remove('has-activated-menu');
				isTransitioning = false;
			}, 300);
			return false;
		};

		const toggleSubNav = (e) => {
			e.preventDefault();
			const icon = e.target;
			const parentLi = icon.closest('li');
			const parent = parentLi.parentNode;

			// Good idea to match with submenu CSS transition-duration
			const animationDelayMs = 200;

			const show = () => {
				siteHeader.classList.add('has-openSubmenus');
				parentLi.classList.add('is-activated');
				setTimeout(function () {
					parentLi.setAttribute('aria-expanded', 'true');
				}, 10);
			};

			const hide = () => {
				siteHeader.classList.remove('has-openSubmenus');
				parentLi.setAttribute('aria-expanded', 'false');
				setTimeout(function () {
					parentLi.classList.remove('is-activated');
				}, animationDelayMs);
			};

			// Hide submenu (if already visible) and return
			if (parentLi.getAttribute('aria-expanded') === 'true') {
				hide();
				return;
			}

			/*
			 * Close all open menus before opening a new one
			 * This is an edge case for top level desktop menu only
			 */
			if (parent && parent.classList.contains('js-siteNav')) {
				collapseOpenSiteNavItems();
			}

			// Show submenu
			show();
		};

		const handleDocumentKeyUp = (e) => {
			// Close menu using Esc key.
			if (e.keyCode === 27) {
				hideOffCanvasSection();
			}
		};

		// Show off canvas menu
		showMenuElement.addEventListener('click', showOffCanvasSection);

		// Hide off canvas menu
		hideMenuElements.forEach((item) => item.addEventListener('click', hideOffCanvasSection));

		// Toggle subnavigation items
		datajsAll('subnav-toggle').forEach((item) => item.addEventListener('click', toggleSubNav));

		// Handle document keyup event
		document.addEventListener('keyup', handleDocumentKeyUp);
	}
}
